/**
 * Route: /splits — Story 2.3-UI (Split-Editor, Referenz splits.html)
 *
 * Layout-Route der Provisions-Regeln: Section-Header + Regel-Liste links,
 * Editor-Spalte rechts (Outlet der Kindrouten).
 * Kindrouten:
 *   /splits         - Hinweis-Karte (keine Regel gewaehlt)
 *   /splits/create  - Editor fuer neue Regel
 *   /splits/:id     - Editor fuer bestehende Regel
 */
import { createFileRoute } from '@tanstack/react-router'
import { SplitsLayout } from '../features/splits/SplitsLayout'

export const Route = createFileRoute('/_auth/splits')({
  component: SplitsLayout,
})
